import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";


import SignService from "../services/sign.service";


const list = {
  list: [],
  pageSize: 25,
  page: 0,
  total: 0,
  nextPage: 0
};

export const getSignMessages= createAsyncThunk(
  "signMessage/getMessages",
  async ({search}, thunkAPI) => {
    try {

      const data = await SignService.getSignMessages(search);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getSignMessage = createAsyncThunk(
  "signMessage/getMessage",
  async (messageID, thunkAPI) => {
    try {
      const data = await SignService.getSignMessage(messageID);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const updateSignMessage = createAsyncThunk(
  "signMessage/updateMessage",
  async ( {message},thunkAPI) => {
    try {
      const data = await SignService.updateSignMessage(message);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createSignMessage = createAsyncThunk(
  "signMessage/createMessage",
  async ( {message},thunkAPI) => {
    try {
      const data = await SignService.createSignMessage(message);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


const initialState = { data: list, loading: false};

const signMessgeSlice = createSlice({
  name: "signMessage",
  initialState,
  extraReducers: {

    [getSignMessages.pending]: (state, action) => {
      state.loading = true;
    },
    [getSignMessages.fulfilled]: (state, action) => {

      state.data = action.payload.data; 
      state.loading = false;
    },
    [getSignMessages.rejected]: (state, action) => {
      state.data = list
      state.loading = false;
    },

    [getSignMessage.pending]: (state, action) => {
      state.loading = true;
    },
    [getSignMessage.fulfilled]: (state, action) => {

      //is sign in list if so change it
      //else push it in

      let messages = state.data.list;
      let thisMessage = messages.find((message) => message.id === action.payload.data.id)

      if(thisMessage){
        Object.assign(thisMessage,action.payload.data)
      }else{
        state.data.list.push(action.payload.data)
        state.data.total ++;
      }

      state.loading = false;
    },
    [getSignMessage.rejected]: (state, action) => {
      state.data = list
      state.loading = false;
    },
    
    [updateSignMessage.fulfilled]: (state, action) => {

      let messages = state.data.list;
      let thisMessage = messages.find((message) => message.id === action.payload.data.id)
      Object.assign(thisMessage,action.payload.data)

    },

  },
});


const { reducer } = signMessgeSlice;
export default reducer;